<template>
  <div style="position: relative;">
    <el-form ref="newsPageEventsFilter" :model="newsPageEvents" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="主题名称" prop="formFilter.subjectName">
          <el-input class="filter-item" v-model="newsPageEvents.formFilter.subjectName"
            :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="审核状态" prop="formFilter.auditStatus">
          <el-select class="filter-item" v-model="newsPageEvents.formFilter.auditStatus" :clearable="true" filterable
            placeholder="" :loading="newsPageEvents.auditStatus.impl.loading"
            @visible-change="newsPageEvents.auditStatus.impl.onVisibleChange"
            @change="onAuditStatusValueChange">
            <el-option v-for="item in newsPageEvents.auditStatus.impl.dropdownList" :key="item.id"
              :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否发布" prop="formFilter.upFlag">
          <el-select class="filter-item" v-model="newsPageEvents.formFilter.upFlag" :clearable="true" filterable
            placeholder="" :loading="newsPageEvents.upFlag.impl.loading"
            @visible-change="newsPageEvents.upFlag.impl.onVisibleChange"
            @change="onUpFlagValueChange">
            <el-option v-for="item in newsPageEvents.upFlag.impl.dropdownList" :key="item.id"
              :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetNewsPageEvents">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshNewsPageEvents(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('newsPageEvents:newsPageEvents:export')"
          @click="onExportClick()">
          导出
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="sysNews" :data="newsPageEvents.SysNews.impl.dataList" :size="defaultFormItemSize" @sort-change="newsPageEvents.SysNews.impl.onSortChange"
          header-cell-class-name="table-header-gray"
          highlight-current-row @current-change="newsPageEvents.SysNews.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="newsPageEvents.SysNews.impl.getTableIndex" />
          <el-table-column label="主题名称" prop="subjectName">
          </el-table-column>
          <el-table-column label="发起人" prop="createUserIdDictMap.name">
          </el-table-column>
          <el-table-column label="审核状态" prop="auditStatusDictMap.name">
          </el-table-column>
          <el-table-column label="发布状态" prop="upFlagDictMap.name">
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime" sortable="custom">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button @click.stop="onNewsPageViewClick(scope.row)" type="text" :size="defaultFormItemSize"
                :disabled="!checkPermCodeExist('newsPageEvents:newsPageEvents:newsPageView')">
                查看
              </el-button>
              <el-button @click.stop="changeUpFlag(scope.row, '1', '发布')" type="text" :size="defaultFormItemSize"
                         v-if="scope.row.upFlag === '0'">
                发布
              </el-button>
              <el-button @click.stop="changeUpFlag(scope.row, '0', '取消发布')" type="text" :size="defaultFormItemSize"
                         v-if="scope.row.upFlag === '1'">
                取消发布
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="newsPageEvents.SysNews.impl.totalCount"
            :current-page="newsPageEvents.SysNews.impl.currentPage"
            :page-size="newsPageEvents.SysNews.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="newsPageEvents.SysNews.impl.onCurrentPageChange"
            @size-change="newsPageEvents.SysNews.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { SysNewsController, DictionaryController } from '@/api';

export default {
  name: 'newsPageEvents',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      newsPageEvents: {
        formFilter: {
          subjectName: undefined,
          auditStatus: undefined,
          upFlag: undefined
        },
        formFilterCopy: {
          subjectName: undefined,
          auditStatus: undefined,
          upFlag: undefined
        },
        SysNews: {
          impl: new TableWidget(this.loadSysNewsWidgetData, this.loadSysNewsVerify, true, true, 'createTime', 1)
        },
        auditStatus: {
          impl: new DropdownWidget(this.loadAuditStatusDropdownList)
        },
        upFlag: {
          impl: new DropdownWidget(this.loadUpFlagDropdownList)
        },
        isInit: false
      }
    }
  },
  methods: {
    onResetNewsPageEvents () {
      this.$refs.newsPageEventsFilter.resetFields();
      this.refreshNewsPageEvents(true);
    },
    /**
     * 新闻通告表数据获取函数，返回Promise
     */
    loadSysNewsWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        sysNewsDtoFilter: {
          infoType: this.InfoTypeDict.DSJ,
          subjectName: this.newsPageEvents.formFilterCopy.subjectName,
          auditStatus: this.newsPageEvents.formFilterCopy.auditStatus,
          upFlag: this.newsPageEvents.formFilterCopy.upFlag
        }
      }
      return new Promise((resolve, reject) => {
        SysNewsController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.newsPageEvents.SysNews.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.newsPageEvents.SysNews.impl.currentRow.id, 'id');
              this.$refs.sysNews.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 新闻通告表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSysNewsVerify () {
      this.newsPageEvents.formFilterCopy.subjectName = this.newsPageEvents.formFilter.subjectName;
      this.newsPageEvents.formFilterCopy.auditStatus = this.newsPageEvents.formFilter.auditStatus;
      this.newsPageEvents.formFilterCopy.upFlag = this.newsPageEvents.formFilter.upFlag;
      return true;
    },
    /**
     * 审核状态下拉数据获取函数
     */
    loadAuditStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAuditStatusDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 审核状态选中值改变
     */
    onAuditStatusValueChange (value) {
    },
    /**
     * 是否发布下拉数据获取函数
     */
    loadUpFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 是否发布选中值改变
     */
    onUpFlagValueChange (value) {
    },
    /**
     * 更新大事记管理
     */
    refreshNewsPageEvents (reloadData = false) {
      if (reloadData) {
        this.newsPageEvents.SysNews.impl.refreshTable(true, 1);
      } else {
        this.newsPageEvents.SysNews.impl.refreshTable();
      }
      if (!this.newsPageEvents.isInit) {
        // 初始化下拉数据
      }
      this.newsPageEvents.isInit = true;
    },
    /**
     * 查看
     */
    onNewsPageViewClick (row) {
      let params = {
        id: row.id
      };

      params.closeVisible = 1;
      this.$router.push({name: 'newsPageView', query: params});
    },
    /**
     * 改变发布状态
     */
    changeUpFlag (row, upFlag, mes) {
      let params = {
        sysNewsDto: {
          id: row.id,
          upFlag: upFlag
        }
      };

      this.$confirm('是否' + mes + '?').then(res => {
        SysNewsController.updateUpFlag(this, params).then(res => {
          this.$message.success(mes + '成功');
          this.newsPageEvents.SysNews.impl.refreshTable();
        }).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 导出
     */
    onExportClick () {
      let params = {
        sysNewsDtoFilter: {
          infoType: this.InfoTypeDict.DSJ,
          subjectName: this.newsPageEvents.formFilterCopy.subjectName,
          auditStatus: this.newsPageEvents.formFilterCopy.auditStatus,
          upFlag: this.newsPageEvents.formFilterCopy.upFlag
        }
      };

      SysNewsController.export(this, params, '新闻通告表.xlsx').then(res => {
        this.$message.success('导出成功');
      }).catch(e => {
        this.$message.error(e.errorMessage);
      });
    },
    onResume () {
      this.refreshNewsPageEvents();
    },
    initFormData () {
    },
    formInit () {
      this.refreshNewsPageEvents();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
